export const TEAM_INFO = {
  '0': {
    name: 'Lena',
    src: '/assets/img/lena.jpg',
    info: 'LenaInfo',
    path: 'https://github.com/ElenaBezro',
  },
  '1': {
    name: 'Andrey',
    src: '/assets/img/andrey.jpg',
    info: 'AndreiInfo',
    path: 'https://github.com/treyer',
  },
  '2': {
    name: 'Marina',
    src: '/assets/img/marina.jpg',
    info: 'MarinaInfo',
    path: 'https://github.com/MarinaPresmytskaia',
  },
};
